export enum ErrorCode {
  RECIPIENT_DOES_NOT_EXISTS = '600',
  SIGNATURE_ERROR = '900',
  ACCOUNT_NOT_FOUND = '901',
  ACCOUNT_DISABLED = '902',
  DOCUMENT_ALREADY_RECEIVED = '903',
}

export const ErrorCodeDescriptions: Partial<Record<ErrorCode, string>> = {
  [ErrorCode.RECIPIENT_DOES_NOT_EXISTS]:
    'Wystąpił błąd podczas próby utworzenia wniosku: Wybrany adresat już nie istnieje',
  [ErrorCode.SIGNATURE_ERROR]:
    'Podpisywanie dokumentu nie powiodło się. Upewnij się, czy czytnik kart jest poprawnie podłączony i zainstalowany oraz czy znajduje się w nim karta.',
};
